import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { apisUrlsData } from "@/data";
import { RoleEnum } from "@/enums";
import { CurrentUserInterface } from "@/interfaces";
import { axios } from "@/lib/axios";
import { setCurrentUserInfo } from "@/redux/actions";
import { RoleType } from "@/types";

export const useAuth = (isAdmin?: boolean) => {
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();

    const rootReducer = useSelector((state) => state as { user: CurrentUserInterface });

    const fetchUserInfoHandler = async () => {
        setLoading(true);

        try {
            const response = await axios.get(
                apisUrlsData.auth.users,
                { isAdmin },
            );

            dispatch(setCurrentUserInfo({
                ...response.data,
                isAdmin,
                isAuthenticated: true,
                ...isAdmin && { role: RoleEnum.SUPER_ADMIN },
            }));

            setLoading(false);
        } catch (error) { // eslint-disable-line
            setLoading(false);

            dispatch(
                setCurrentUserInfo({
                    createdTimestamp: new Date(),
                    email: "",
                    emailVerified: false,
                    enabled: false,
                    firstName: "",
                    id: "",
                    isAdmin: false,
                    isAuthenticated: false,
                    lastName: "",
                    role: "" as RoleType,
                    username: "",
                }),
            );
        }
    };

    return {
        fetchUserInfoHandler,
        loading,
        user: rootReducer.user,
    };
};
